import { series } from 'async';

const selfCancellingAjax = require('../../../admin/assets/js/common/self-canceling-ajax');

module.exports = (email, callback) => {
	const addresses = email
		.replace(/\s/g, '') //we don't need no stinkin whitespace
		.replace(/,/g, ';') //normalize all comma delimiters to semicolons
		.split(';') //split on semicolons
		.filter((x) => x.length); //get rid of empty items (repeated delimiters)
	const queue = [];
	for (const e in addresses) {
		queue.push(emailChecker(addresses[e]));
	}
	series(queue, (err, results) => {
		if (err) {
			//couldn't figure it out client side, so let server-side handle it.
			console.error(err);
			return callback(null, {
				valid: true
			});
		}
		for (let r in results) {
			if (!results[r].valid) {
				const invalidResults = results.filter(r => !r.valid).map(result => ({
					...result,
					email: addresses[results.indexOf(result)]
				}));
				return callback(null, {
					...results[r],
					invalidResults
				});
			}
		}
		return callback(null, {
			valid: true
		});
	});
};

const emailChecker = (email) => {
	return (callback) => {
		selfCancellingAjax(
			'emailValidation',
			{
				url: `${window.location.protocol}//${window.location.host}/admin/index.cfm/mail:main/validateEmail?email=${email}`,
				dataType: 'json'
			},
			(data, textStatus, xhr) => {
				return callback(null, data);
			},
			(xhr, textStatus, errorThrown) => {
				var err = new Error('Error while validating email address (does not indicate invalid email address)');
				console.error(textStatus, errorThrown, xhr);
				return callback(err);
			}
		);
	};
};
